export default __webpack_public_path__ + "cb43aff8638bbb8bf0a07d586bc098a1.png";